export default [
  {
    label: 'core.system',
    icon: 'pi pi-fw pi-cog',
    items: [
      {
        label: 'core.system',
        icon: 'pi pi-fw pi-cog',
        items: [
          {
            label: 'core.users',
            requiredPermissions: [
              'POST api/system/users/{id}',
              'DELETE api/system/users/{id}'
            ],
            target: 'system.user_list'
          },
          {
            label: 'core.roles',
            requiredPermissions: [
              'POST api/system/roles/{id}',
              'DELETE api/system/roles/{id}'
            ],
            target: 'system.role_list'
          },
          {
            label: 'core.permissions',
            requiredPermissions: [
              'POST api/system/permissions/{id}',
              'DELETE api/system/permissions/{id}'
            ],
            target: 'system.permission_list'
          },
          {
            label: 'core.mail_routes',
            requiredPermissions: [
              'POST api/system/mailroutes/{id}',
              'DELETE api/system/mailroutes/{id}'
            ],
            target: 'system.mail_route_list'
          },
          {
            label: 'project.companies',
            requiredPermissions: [
              'GET api/system/companies'
            ],
            target: 'system.company_list'
          }
        ]
      }
    ]
  },
  {
    label: 'sales.sales',
    icon: 'pi pi-fw pi-shopping-cart',
    items: [
      {
        label: 'sales.sales',
        icon: 'pi pi-fw pi-shopping-cart',
        items: [
          {
            label: 'sales.customers',
            requiredPermissions: [
              'GET api/sales/customers'
            ],
            target: 'sales.customers.index'
          },
          {
            label: 'sales.customer_orders',
            requiredPermissions: [
              'GET api/sales/customer-orders'
            ],
            target: 'sales.customer_orders.index'
          },
          {
            label: 'sales.pending_invoices',
            requiredPermissions: [
              'GET api/sales/customer-orders'
            ],
            target: 'sales.pending_invoices.index'
          },
          {
            label: 'sales.quotations',
            requiredPermissions: [
              'GET api/sales/quotations'
            ],
            target: 'sales.quotations.index'
          }
        ]
      }
    ]
  },

  {
    label: 'accounting.accounting',
    icon: 'pi pi-fw pi-money-bill',
    items: [
      {
        label: 'accounting.accounting',
        icon: 'pi pi-fw pi-money-bill',
        items: [
          {
            label: 'accounting.configuration',
            requiredPermissions: [
              'GET api/accounting/accounts'
            ],
            target: 'accounting.configuration'
          },
          {
            label: 'accounting.transactions',
            requiredPermissions: [
              'GET api/accounting/transactions'
            ],
            target: 'accounting.transaction_list'
          },
          {
            label: 'accounting.reports',
            requiredPermissions: [
              'GET api/accounting/reports/balance-sheet'
            ],
            target: 'accounting.reports'
          },
          {
            label: 'accounting.vendors',
            requiredPermissions: [
              'GET api/accounting/vendors'
            ],
            target: 'accounting.vendors.index'
          },
          {
            label: 'accounting.vendor_bills',
            requiredPermissions: [
              'GET api/accounting/vendor-bills'
            ],
            target: 'accounting.vendor-bills.index'
          },
          {
            label: 'accounting.expenses',
            requiredPermissions: [
              'GET api/accounting/expenses'
            ],
            target: 'accounting.expenses.index'
          },

          {
            label: 'accounting.bank_statements',
            requiredPermissions: [
              'GET api/accounting/bank-statements'
            ],
            target: 'accounting.bank-statements.index'
          },
          {
            label: 'accounting.customer_invoices',
            requiredPermissions: [
              'GET api/accounting/customer-invoices'
            ],
            target: 'accounting.customer-invoices.index'
          },
          {
            label: 'accounting.aging_report',
            requiredPermissions: [
              'GET api/accounting/reports/aging'
            ],
            target: 'accounting.reports.aging'
          },

        ]
      }
    ]
  },
  {
    label: 'project.project_management',
    icon: 'pi pi-fw pi-briefcase',
    items: [
      {
        label: 'project.project_management',
        icon: 'pi pi-fw pi-briefcase',
        items: [
          {
            label: 'project.overview',
            requiredPermissions: [
              'GET odata/Issues'
            ],
            target: 'project_management.overview'
          },
          {
            label: 'project.project_definition',
            requiredPermissions: [
              'POST odata/Projects'
            ],
            target: 'project_management.project_definition_list'
          },
          {
            label: 'project.timelogs',
            requiredPermissions: [
              'GET odata/Timelogs'
            ],
            target: 'project_management.timelog'
          },
          {
            label: 'project.project_invoices',
            requiredPermissions: [
              'POST odata/ProjectInvoices'
            ],
            target: 'project_management.invoice'
          },
          {
            label: 'project.board',
            requiredPermissions: [
              'GET odata/Issues'
            ],
            target: 'project_management.board'
          },
          {
            label: 'project.notifications',
            requiredPermissions: [
              'GET odata/Issues'
            ],
            target: 'project_management.notifications'
          }
        ]
      },
    ]
  },
  {
    label: 'documents.module',
    icon: 'pi pi-fw pi-folder',
    items: [
      {
        label: 'documents.module',
        icon: 'pi pi-fw pi-folder',
        requiredPermissions: [
          'GET api/drive/spaces'
        ],
        target: 'documents.index'
      }
    ]
  },
  {
    label: 'project.wiki',
    icon: 'pi pi-fw pi-book',
    items: [
      {
        label: 'project.wiki',
        icon: 'pi pi-fw pi-book',
        requiredPermissions: [
          'GET api/project/projects-with-wiki'
        ],
        target: 'project_management.wiki_list'
      }
    ]
  },
  {
    label: 'mail.mail',
    icon: 'pi pi-fw pi-envelope',
    badgeKey: 'mailUnreadCount',
    items: [
      {
        label: 'mail.mail',
        icon: 'pi pi-fw pi-envelope',
        badgeKey: 'mailUnreadCount',
        requiredPermissions: [
          'GET odata/MailAccounts'
        ],
        target: 'mail.inbox'
      }
    ]
  },
  {
    label: 'chat.chat',
    icon: 'pi pi-fw pi-comments',
    badgeKey: 'chatUnreadCount',
    items: [
      {
        label: 'chat.chat',
        icon: 'pi pi-fw pi-comments',
        badgeKey: 'chatUnreadCount',
        requiredPermissions: [
          'GET api/chat/channels'
        ],
        target: 'chat.index'
      }
    ]
  },
  {
    label: 'contacts.contacts',
    icon: 'pi pi-fw pi-users',
    items: [
      {
        label: 'contacts.contacts',
        icon: 'pi pi-fw pi-users',
        requiredPermissions: [
          'GET odata/AddressBooks'
        ],
        target: 'contacts.index'
      }
    ]
  },
  {
    label: 'calendar.calendar',
    icon: 'pi pi-fw pi-calendar',
    items: [
      {
        label: 'calendar.calendar',
        icon: 'pi pi-fw pi-calendar',
        requiredPermissions: [
          'GET odata/Calendars'
        ],
        target: 'calendar.index'
      }
    ]
  },
  {
    label: 'cloudpanel.cloud_panel',
    icon: 'pi pi-fw pi-server',
    items: [
      {
        label: 'cloudpanel.cloud_panel',
        icon: 'pi pi-fw pi-server',
        items: [
          {
            label: 'cloudpanel.servers',
            requiredPermissions: [
              'GET odata/CloudPanelServers'
            ],
            target: 'cloudpanel.servers.index'
          },
          {
            label: 'cloudpanel.sites',
            requiredPermissions: [
              'GET odata/CloudPanelSites'
            ],
            target: 'cloudpanel.sites.index'
          },
          {
            label: 'cloudpanel.system_users',
            requiredPermissions: [
              'GET odata/CloudPanelSystemUsers'
            ],
            target: 'cloudpanel.system-users.index'
          },
          {
            label: 'cloudpanel.ssh_key_vault',
            requiredPermissions: [
              'GET odata/CloudPanelSshKeys'
            ],
            target: 'cloudpanel.ssh-keys.index'
          },
          {
            label: 'cloudpanel.firewall',
            requiredPermissions: [
              'GET odata/CloudPanelFirewallRules'
            ],
            target: 'cloudpanel.firewall.index'
          },
          {
            label: 'cloudpanel.databases',
            requiredPermissions: [
              'GET odata/CloudPanelDatabases'
            ],
            target: 'cloudpanel.databases.index'
          },
          {
            label: 'cloudpanel.database_users',
            requiredPermissions: [
              'GET odata/CloudPanelDatabaseUsers'
            ],
            target: 'cloudpanel.database-users.index'
          },
          {
            label: 'cloudpanel.cronjobs',
            requiredPermissions: [
              'GET odata/CloudPanelCronjobs'
            ],
            target: 'cloudpanel.cronjobs.index'
          },
          {
            label: 'cloudpanel.supervisor_programs',
            requiredPermissions: [
              'GET odata/CloudPanelSupervisorPrograms'
            ],
            target: 'cloudpanel.supervisor.index'
          },
          {
            label: 'cloudpanel.backups',
            requiredPermissions: [
              'GET odata/CloudPanelBackups'
            ],
            target: 'cloudpanel.backups.index'
          },
          {
            label: 'cloudpanel.backup_storages',
            requiredPermissions: [
              'GET odata/CloudPanelBackupStorages'
            ],
            target: 'cloudpanel.backup-storages.index'
          },
          {
            label: 'cloudpanel.settings',
            requiredPermissions: [
              'GET api/cloudpanel/certificates/status'
            ],
            target: 'cloudpanel.settings'
          }
        ]
      }
    ]
  },
  {
    label: 'telemetry.telemetry',
    icon: 'pi pi-fw pi-chart-bar',
    items: [
      {
        label: 'telemetry.telemetry',
        icon: 'pi pi-fw pi-chart-bar',
        items: [
          {
            label: 'telemetry.projects',
            requiredPermissions: [
              'GET odata/TelemetryProjects'
            ],
            target: 'telemetry.projects.index'
          },
          {
            label: 'telemetry.errors',
            requiredPermissions: [
              'GET odata/TelemetryErrorGroups'
            ],
            target: 'telemetry.errors.index'
          },
          {
            label: 'telemetry.performance',
            requiredPermissions: [
              'GET odata/TelemetryTransactions'
            ],
            target: 'telemetry.transactions.index'
          }
        ]
      }
    ]
  }
]